import styled from "styled-components";

export const MainContent = styled.div`
  margin-left: 240px;
  padding: 20px;
  min-height: 100vh;
  background-color: ${props => props.theme.colors.surfaceAlt};
`;

export const HeaderWrapper = styled.header`
  margin-left: ${(props) => (props.isSidebarExpanded ? "240px" : "80px")};
  transition: margin-left 0.3s ease;
  background-color: ${props => props.theme.colors.headerAlt};
  color: ${props => props.theme.colors.onColor};
  padding: 12px 24px;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  position: relative;
`;